import React, {useEffect} from 'react'

import {logOutUser} from 'utils/user'
import useUserContext from 'components/User/useUserContext'

const Logout = () => {
  const {setUser, setDelivery} = useUserContext()

  useEffect(() => {
    logOutUser(setUser, setDelivery)
  }, [setUser, setDelivery])

  return (
    <div>
      logged out
    </div>
  )
}

export default Logout
